module.exports = __webpack_public_path__ + "static/end-zoom-552db635c1e9768845fdfe558d990285.jpg";